import {Point} from '@logistics-frontend/core/types'
import {Brand} from '@logistics-frontend/server/controllers/lib/getBrand'
import {Country} from '@logistics-frontend/types'

type AppVersion = '3' | '2'

type AppVersionByDevice = {
  desktop: AppVersion
  mobile: AppVersion
}

export type AppConfig = {
  config: {
    dir: 'rtl' | 'ltr'
    lang: string
    countries: Record<string, Country>
    detectedCountry: string
    basename?: string
    b2bApiHost?: string
    appVersion: AppVersionByDevice
    mapLang: string
    location: Point
    branding: Brand
  }
  i18n: Record<string, unknown>
}

export const __NAME__ = '__TARIFFS_CONFIG__'
